(function ($) {
  /**
   * For each element with class .number, this function looks for the following data attributes:
   * data-count, data-prefix, data-suffix
   * If the element is visible in the viewport, the function will use the data-count attribute to
   * count up to the number, appending the prefix/suffix and adding commas where necessary
   */

  // @link https://stackoverflow.com/questions/49877610/modify-countup-jquery-functions-to-include-commas
  function addCommas(nStr) {
    return nStr.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  }

  function initialiseCountUp() {
    // Only run if IntersectionObserver supported
    if (!!window.IntersectionObserver) {
      // @link https://css-tricks.com/a-few-functional-uses-for-intersection-observer-to-know-when-an-element-is-in-view/

      let countUpObserver = new IntersectionObserver(
        (entries, countUpObserver) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              countUp(entry.target);
              // countUpObserver.unobserve(entry.target); // Comment in to turn off observing (animate only once)
            }
          });
        },
        { rootMargin: "0px 0px -20px 0px" },
      ); // Wait until a slither of the number is visible
      document
        .querySelectorAll(".count-up")
        .forEach((number) => countUpObserver.observe(number));
    }
  }

  function convertLargeNumber(numString) {
    // Check if this is a whole number (no decimal point)
    if (!/^[\d,]+$/.test(numString)) {
      return [numString]; // Return as single-item array if not a whole number
    }

    // Remove commas and convert to number
    var num = parseInt(numString.replace(/,/g, ""));

    var convertedNumber, convertedSuffix;

    if (num >= 1000000000000) {
      convertedNumber = (num / 1000000000000).toFixed(1);
      convertedSuffix = "tn";
    } else if (num >= 1000000000) {
      convertedNumber = (num / 1000000000).toFixed(1);
      convertedSuffix = "bn";
    } else if (num >= 1000000) {
      convertedNumber = (num / 1000000).toFixed(2);
      convertedSuffix = "mn";
    } else if (num >= 100000) {
      convertedNumber = (num / 1000).toFixed(0);
      convertedSuffix = "k";
    } else if (num >= 10000) {
      convertedNumber = (num / 1000).toFixed(1);
      convertedSuffix = "k";
    } else {
      convertedNumber = num.toString();
      convertedSuffix = "";
    }

    // Return array of parts
    if (convertedSuffix) {
      return [convertedNumber, convertedSuffix];
    } else {
      return [convertedNumber];
    }
  }

  function countUp(number) {
    var $this = $(number);

    // Check if already processed - if so, just re-animate
    if ($this.hasClass("count-processed")) {
      $this.find(".number").each(function () {
        animateNumber(this);
      });
      return;
    }

    // Get the initialValue and remove HTML comments
    var initialValue = $this.attr("data-value");

    // Bail if no value
    if (!initialValue) {
      return;
    }

    initialValue = initialValue.replace(/<!--[\s\S]*?-->/g, "");

    // Split into parts: numbers (including decimals and commas) and non-numbers
    var parts = initialValue.match(/[\d,\.]+|[^\d,\.]+/g) || [];

    // Clean up parts - remove empty strings and trim whitespace
    parts = parts.map((part) => part.trim()).filter((part) => part.length > 0);

    // Process parts - convert large whole numbers
    var processedParts = [];

    for (var i = 0; i < parts.length; i++) {
      var converted = convertLargeNumber(parts[i]);
      processedParts = processedParts.concat(converted);
    }

    // Helper to check if a string is a symbol (non-alphanumeric)
    function isSymbol(str) {
      return /^[^a-zA-Z0-9]+$/.test(str);
    }

    // Helper to check if symbol should be a prefix (currency symbols typically)
    function isPrefixSymbol(str) {
      return /^[£$€¥₹]+$/.test(str);
    }

    // Helper to check if symbol should be a suffix (%, +, -, etc)
    function isSuffixSymbol(str) {
      return isSymbol(str) && !isPrefixSymbol(str);
    }

    // Build new HTML with spans
    var newHTML = "";

    processedParts.forEach(function (part, index) {
      // Add space before this part if needed
      if (index > 0) {
        var previousPart = processedParts[index - 1];
        var needsSpace = true;

        // Don't add space if previous part is a prefix symbol
        if (isPrefixSymbol(previousPart)) {
          needsSpace = false;
        }

        // Don't add space if current part is a suffix symbol
        if (isSuffixSymbol(part)) {
          needsSpace = false;
        }

        if (needsSpace) {
          newHTML += " ";
        }
      }

      // Check if this part is a number (including decimals)
      if (/^[\d\.]+$/.test(part)) {
        // Count digits (excluding decimal point)
        var numDigits = part.split(".")[0].length;
        var duration;

        if (numDigits <= 2) {
          duration = 750;
        } else if (numDigits === 3) {
          duration = 1500;
        } else if (numDigits === 4) {
          duration = 2250;
        } else {
          duration = 3000;
        }

        newHTML +=
          '<span class="number" data-count="' +
          part +
          '" data-duration="' +
          duration +
          '">0</span>';
      } else {
        // Text part
        newHTML += '<span class="text-small">' + part + "</span>";
      }
    });

    // Replace the HTML and mark as processed
    $this.html(newHTML);
    $this.addClass("count-processed");

    // Initialize counting for all .number spans inside this element
    $this.find(".number").each(function () {
      animateNumber(this);
    });
  }
  function animateNumber(element) {
    var $el = $(element);
    var countTo = parseFloat($el.attr("data-count"));
    var duration = parseInt($el.attr("data-duration"));

    // Reset to 0 before animating
    $el.text("0");

    $({ countNum: 0 }).animate(
      {
        countNum: countTo,
      },
      {
        duration: duration,
        easing: "linear",
        step: function () {
          $el.text(Math.floor(this.countNum));
        },
        complete: function () {
          $el.text(this.countNum);
        },
      },
    );
  }

  document.addEventListener("DOMContentLoaded", function () {
    initialiseCountUp();
  });
})(jQuery);
